document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('.split-banner-slideshow');

  sections.forEach((section) => {
    const slides = section.querySelectorAll('.split-banner-slide');
    const dots = section.querySelectorAll('.split-banner-slideshow__dot');
    const prevButton = section.querySelector('[data-action="prev"]');
    const nextButton = section.querySelector('[data-action="next"]');

    if (!slides.length) return;

    let currentIndex = 0;
    let timer = null;

    const autoplayEnabled = section.dataset.autoplay === 'true';
    const speed = parseInt(section.dataset.speed || '4000', 10);

    function updateSlides(index) {
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === index);
      });

      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === index);
      });

      currentIndex = index;
    }

    function nextSlide() {
      const nextIndex = (currentIndex + 1) % slides.length;
      updateSlides(nextIndex);
    }

    function prevSlide() {
      const prevIndex = (currentIndex - 1 + slides.length) % slides.length;
      updateSlides(prevIndex);
    }

    function startAutoplay() {
      if (!autoplayEnabled || slides.length <= 1) return;
      stopAutoplay();
      timer = setInterval(nextSlide, speed);
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => {
        nextSlide();
        startAutoplay();
      });
    }

    if (prevButton) {
      prevButton.addEventListener('click', () => {
        prevSlide();
        startAutoplay();
      });
    }

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.dataset.dotIndex || '0', 10);
        updateSlides(index);
        startAutoplay();
      });
    });

    section.addEventListener('mouseenter', stopAutoplay);
    section.addEventListener('mouseleave', startAutoplay);

    updateSlides(0);
    startAutoplay();
  });
});